<template>
  <div class="d-flex align-items-center justify-content-center">
    <h2>Error 404</h2>
  </div>
</template>
